/*
 * Special stats that may be used for billing.
 * How to add new utilization metrics:
 * https://notable-health.atlassian.net/wiki/spaces/notableengineering/pages/3453583437/How+to+add+new+utilization+metrics
 */
export var FlowActionUnit;
(function (FlowActionUnit) {
    FlowActionUnit["AuthorizationSubmissionApiCalls"] = "AuthorizationSubmissionApiCalls";
    FlowActionUnit["BlockCompleted"] = "BlockCompleted";
    FlowActionUnit["BotMinutes"] = "BotMinutes";
    FlowActionUnit["BotSeconds"] = "BotSeconds";
    FlowActionUnit["BrandedCallCompleted"] = "BrandedCallCompleted";
    FlowActionUnit["CommunicationWindowBlocked"] = "CommunicationWindowBlocked";
    FlowActionUnit["CommunicationWindowQueued"] = "CommunicationWindowQueued";
    FlowActionUnit["CpuTimeMilliseconds"] = "CpuTimeMilliseconds";
    FlowActionUnit["CreateNotableObject"] = "CreateNotableObject";
    FlowActionUnit["DocumentGenerated"] = "DocumentGenerated";
    FlowActionUnit["DocumentsExtracted"] = "DocumentsExtracted";
    FlowActionUnit["EmailSent"] = "EmailSent";
    FlowActionUnit["EntityLookups"] = "EntityLookups";
    FlowActionUnit["EvaluationCharacters"] = "EvaluationCharacters";
    FlowActionUnit["FaxPagesSent"] = "FaxPagesSent";
    FlowActionUnit["FhirApiCalls"] = "FhirApiCalls";
    FlowActionUnit["FileConverted"] = "FileConverted";
    FlowActionUnit["FormsSelected"] = "FormsSelected";
    FlowActionUnit["GcsBytesRead"] = "GcsBytesRead";
    FlowActionUnit["GcsBytesWritten"] = "GcsBytesWritten";
    FlowActionUnit["GetNotableObject"] = "GetNotableObject";
    FlowActionUnit["HccFindingsExported"] = "HccFindingsExported";
    FlowActionUnit["HccFindingsSuspected"] = "HccFindingsSuspected";
    FlowActionUnit["HccSuspectingCompleted"] = "HccSuspectingCompleted";
    FlowActionUnit["Hl7CallAcknowledged"] = "Hl7CallAcknowledged";
    FlowActionUnit["HumanTaskCreated"] = "HumanTaskCreated";
    FlowActionUnit["HumanTaskCompleted"] = "HumanTaskCompleted";
    FlowActionUnit["HumanTaskExpired"] = "HumanTaskExpired";
    FlowActionUnit["HumanTaskReviewMinutes"] = "HumanTaskReviewMinutes";
    FlowActionUnit["HumanTaskNotableReviewMinutes"] = "HumanTaskNotableReviewMinutes";
    FlowActionUnit["HumanTaskSidekickCreated"] = "HumanTaskSidekickCreated";
    FlowActionUnit["HumanTaskSidekickCompleted"] = "HumanTaskSidekickCompleted";
    FlowActionUnit["InsuranceCardsExtracted"] = "InsuranceCardsExtracted";
    FlowActionUnit["Iteration"] = "Iteration";
    FlowActionUnit["ListFiltered"] = "ListFiltered";
    FlowActionUnit["LlmInputTokens"] = "LlmInputTokens";
    FlowActionUnit["LlmCachedInputTokens"] = "LlmCachedInputTokens";
    FlowActionUnit["LlmOutputTokens"] = "LlmOutputTokens";
    FlowActionUnit["RestApiRequests"] = "RestApiRequests";
    FlowActionUnit["OcrPagesProcessed"] = "OcrPagesProcessed";
    FlowActionUnit["Output"] = "Output";
    FlowActionUnit["PatientDataStoreApiCalls"] = "PatientDataStoreApiCalls";
    FlowActionUnit["PatientDataStoreDocumentTranscriptions"] = "PatientDataStoreDocumentTranscriptions";
    FlowActionUnit["SftpBytesWritten"] = "SftpBytesWritten";
    FlowActionUnit["SkillCompleted"] = "SkillCompleted";
    FlowActionUnit["SubflowCompleted"] = "SubflowCompleted";
    FlowActionUnit["SmsSegmentsSent"] = "SmsSegmentsSent";
    FlowActionUnit["TextCharacterLength"] = "TextCharacterLength";
    FlowActionUnit["UpdateNotableObject"] = "UpdateNotableObject";
    FlowActionUnit["VoiceCallMinutes"] = "VoiceCallMinutes";
    FlowActionUnit["VoiceMinutesTranscribed"] = "VoiceMinutesTranscribed";
    FlowActionUnit["VoiceCallToolAuthenticateInboundPatient"] = "VoiceCallToolAuthenticateInboundPatient";
    FlowActionUnit["VoiceCallToolAuthenticateKnownPatient"] = "VoiceCallToolAuthenticateKnownPatient";
    FlowActionUnit["VoiceCallToolBookSelectedSlot"] = "VoiceCallToolBookSelectedSlot";
    FlowActionUnit["VoiceCallToolCreatePatient"] = "VoiceCallToolCreatePatient";
    FlowActionUnit["VoiceCallToolGetPatient"] = "VoiceCallToolGetPatient";
    FlowActionUnit["VoiceCallToolGetEncounters"] = "VoiceCallToolGetEncounters";
    FlowActionUnit["VoiceCallToolGetInsurance"] = "VoiceCallToolGetInsurance";
    FlowActionUnit["VoiceCallToolGetOrders"] = "VoiceCallToolGetOrders";
    FlowActionUnit["VoiceCallToolLookupPatient"] = "VoiceCallToolLookupPatient";
    FlowActionUnit["VoiceCallToolSearchForOpenSlots"] = "VoiceCallToolSearchForOpenSlots";
    FlowActionUnit["VoiceCallToolSendInboundAuthCode"] = "VoiceCallToolSendInboundAuthCode";
    FlowActionUnit["VoiceCallToolSendSms"] = "VoiceCallToolSendSms";
    FlowActionUnit["VoiceCallToolTraverseDecisionTree"] = "VoiceCallToolTraverseDecisionTree";
    FlowActionUnit["VoiceCallToolGetAppointments"] = "VoiceCallToolGetAppointments";
    FlowActionUnit["VoiceCallToolGetPracticeDetails"] = "VoiceCallToolGetPracticeDetails";
    FlowActionUnit["VoiceCallToolGetTimeDifference"] = "VoiceCallToolGetTimeDifference";
    FlowActionUnit["VoiceCallToolGeneric"] = "VoiceCallToolGeneric";
    FlowActionUnit["WaitTimeSeconds"] = "WaitTimeSeconds";
})(FlowActionUnit || (FlowActionUnit = {}));
//# sourceMappingURL=actionUnit.js.map